module.exports = __webpack_public_path__ + "img/boxes_random.287dfde6.png";